/* 
* This file is auto-generated by Graphweaver. 
* Please do not edit it directly.
*/
import * as Types from '../../../../../backend/src/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCouncilStatsQueryVariables = Types.Exact<{
  startDate?: Types.InputMaybe<Types.Scalars['String']['input']>;
  endDate?: Types.InputMaybe<Types.Scalars['String']['input']>;
  councilId: Types.Scalars['Float']['input'];
  material?: Types.InputMaybe<Types.MaterialType>;
}>;


export type GetCouncilStatsQuery = { __typename?: 'Query', getCouncilStats?: { __typename?: 'CouncilStats', councilId: number, details: { __typename?: 'CouncilStatsDetails', accountsTotal: number, accountsCreated: number, scanEvents: number, kgDiverted: number, subscriptions: Array<{ __typename?: 'SubscriptionCount', productId: string, productName: string, count: number }> }, suburbs: Array<{ __typename?: 'CouncilStatsSuburb', suburbId: number, suburbName: string, details: { __typename?: 'CouncilStatsDetails', accountsTotal: number, accountsCreated: number, scanEvents: number, kgDiverted: number, subscriptions: Array<{ __typename?: 'SubscriptionCount', productId: string, productName: string, count: number }> } }> } | null };

export type GetCouncilSuburbsQueryVariables = Types.Exact<{
  councilId: Types.Scalars['ID']['input'];
}>;


export type GetCouncilSuburbsQuery = { __typename?: 'Query', council?: { __typename?: 'Council', id: string, placeId?: string | null, suburbs: Array<{ __typename?: 'Suburb', id: string, placeId?: string | null, displayName: string, uniqueName: string, boundaryFeature?: any | null, isCustomMapFeature: boolean }> } | null };


export const GetCouncilStatsDocument = gql`
    query GetCouncilStats($startDate: String, $endDate: String, $councilId: Float!, $material: MaterialType) {
  getCouncilStats(
    startDate: $startDate
    endDate: $endDate
    councilId: $councilId
    material: $material
  ) {
    councilId
    details {
      accountsTotal
      accountsCreated
      scanEvents
      kgDiverted
      subscriptions {
        productId
        productName
        count
      }
    }
    suburbs {
      suburbId
      suburbName
      details {
        accountsTotal
        accountsCreated
        scanEvents
        kgDiverted
        subscriptions {
          productId
          productName
          count
        }
      }
    }
  }
}
    `;

/**
 * __useGetCouncilStatsQuery__
 *
 * To run a query within a React component, call `useGetCouncilStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCouncilStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCouncilStatsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      councilId: // value for 'councilId'
 *      material: // value for 'material'
 *   },
 * });
 */
export function useGetCouncilStatsQuery(baseOptions: Apollo.QueryHookOptions<GetCouncilStatsQuery, GetCouncilStatsQueryVariables> & ({ variables: GetCouncilStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCouncilStatsQuery, GetCouncilStatsQueryVariables>(GetCouncilStatsDocument, options);
      }
export function useGetCouncilStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCouncilStatsQuery, GetCouncilStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCouncilStatsQuery, GetCouncilStatsQueryVariables>(GetCouncilStatsDocument, options);
        }
export function useGetCouncilStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCouncilStatsQuery, GetCouncilStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCouncilStatsQuery, GetCouncilStatsQueryVariables>(GetCouncilStatsDocument, options);
        }
export type GetCouncilStatsQueryHookResult = ReturnType<typeof useGetCouncilStatsQuery>;
export type GetCouncilStatsLazyQueryHookResult = ReturnType<typeof useGetCouncilStatsLazyQuery>;
export type GetCouncilStatsSuspenseQueryHookResult = ReturnType<typeof useGetCouncilStatsSuspenseQuery>;
export type GetCouncilStatsQueryResult = Apollo.QueryResult<GetCouncilStatsQuery, GetCouncilStatsQueryVariables>;
export const GetCouncilSuburbsDocument = gql`
    query GetCouncilSuburbs($councilId: ID!) {
  council(id: $councilId) {
    id
    placeId
    suburbs {
      id
      placeId
      displayName
      uniqueName
      boundaryFeature
      isCustomMapFeature
    }
  }
}
    `;

/**
 * __useGetCouncilSuburbsQuery__
 *
 * To run a query within a React component, call `useGetCouncilSuburbsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCouncilSuburbsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCouncilSuburbsQuery({
 *   variables: {
 *      councilId: // value for 'councilId'
 *   },
 * });
 */
export function useGetCouncilSuburbsQuery(baseOptions: Apollo.QueryHookOptions<GetCouncilSuburbsQuery, GetCouncilSuburbsQueryVariables> & ({ variables: GetCouncilSuburbsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCouncilSuburbsQuery, GetCouncilSuburbsQueryVariables>(GetCouncilSuburbsDocument, options);
      }
export function useGetCouncilSuburbsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCouncilSuburbsQuery, GetCouncilSuburbsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCouncilSuburbsQuery, GetCouncilSuburbsQueryVariables>(GetCouncilSuburbsDocument, options);
        }
export function useGetCouncilSuburbsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCouncilSuburbsQuery, GetCouncilSuburbsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCouncilSuburbsQuery, GetCouncilSuburbsQueryVariables>(GetCouncilSuburbsDocument, options);
        }
export type GetCouncilSuburbsQueryHookResult = ReturnType<typeof useGetCouncilSuburbsQuery>;
export type GetCouncilSuburbsLazyQueryHookResult = ReturnType<typeof useGetCouncilSuburbsLazyQuery>;
export type GetCouncilSuburbsSuspenseQueryHookResult = ReturnType<typeof useGetCouncilSuburbsSuspenseQuery>;
export type GetCouncilSuburbsQueryResult = Apollo.QueryResult<GetCouncilSuburbsQuery, GetCouncilSuburbsQueryVariables>;